import { captureException } from '@sentry/angular';

export const logError: (...args: Parameters<typeof captureException>) => void = ngDevMode
  ? console.error
  : captureException;
